export enum ComputeFunctionType {
  BOOLEAN_WEIGHTED_SCORE = 'computeBooleanWeightedScore',
  SCREENING_OUTCOME = 'computeScreeningOutcome',
}

export type ComputeFunction = (
  params: Record<string, unknown>,
  context?: Record<string, unknown>
) => boolean
